import { useSelector } from 'react-redux';

import {
  SHOWCASE_ALLOWED_SORT_FIELDS,
  useFilteredConfigViewFields,
} from '~/components/v2/components/showcase/hooks/useFilteredConfigViewFields';
import { currentViewTypeNameSelector } from '~/store/configViews/selectors';
import { useGetPublicConfigViewOptions } from '~/swr-hooks/gallery/viewFields/useGetPublicConfigViewsOptions';

/**
 * Showcase home sort allowlist. Custom Sort is offered by ViewSortingMenu when a centralized
 * board exists, not by sniffing activeBoardId here.
 */
export const usePublicShowcaseConfigViewFields = () => {
  const currentViewTypeName = useSelector(currentViewTypeNameSelector);
  const { data: configViewOptions } = useGetPublicConfigViewOptions({ viewType: currentViewTypeName });

  useFilteredConfigViewFields({
    allowedSortFields: SHOWCASE_ALLOWED_SORT_FIELDS,
    configViewOptions,
  });
};
